import { render } from "./SourceReferences.vue?vue&type=template&id=761d36d2"
import script from "./SourceReferences.vue?vue&type=script&lang=js"
export * from "./SourceReferences.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__